var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fa-stack",class:{ 'font-size': _vm.computedFontSize },on:{"click":function($event){return _vm.xButtonClicked()}}},[_c('i',{staticClass:"fa fa-circle fa-stack-2x"}),_vm._v(" "),_c('i',{staticClass:"fas fa-times fa-stack-1x"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af535334","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/buttons/CircleEnclosedXButton.vue
// module id = null
// module chunks = 